import * as React from 'react';
import { FormLayoutWidget } from '../../../../widgets/layout/FormLayoutWidget';
import { GroupedButtons } from '../../../../widgets/buttons/GroupedButtons';
import { ButtonType } from '../../../../widgets/buttons/ButtonWidget';
import { MarkdownWidget } from '../../../../widgets/MarkdownWidget';
import { styled } from '../../../../theme';
import { useEffect } from 'react';
import { useSystem } from '../../../../hooks/useSystem';

export interface EnterprisePlanStepWidgetProps {
  close: () => any;
}

export const EnterprisePlanStepWidget: React.FC<EnterprisePlanStepWidgetProps> = (props) => {
  const system = useSystem();
  useEffect(() => {
    system.accountsPortalClient.upgradeToEnterprise();
  }, []);
  return (
    <FormLayoutWidget
      sections={[
        {
          key: 'select',
          elements: [
            <S.Markdown
              content={{
                text: `
# Thanks for your interest!

We have noted your intent to upgrade to an Enterprise plan, and an account representative has been notified.

Keep an eye out for an email with more information.
              `
              }}
            />
          ]
        },
        {
          key: 'buttons',
          elements: [
            <GroupedButtons
              btns={[
                {
                  type: ButtonType.PRIMARY,
                  label: 'Close',
                  action: () => {
                    props.close();
                  }
                }
              ]}
            />
          ]
        }
      ]}
    />
  );
};
namespace S {
  export const Markdown = styled(MarkdownWidget)`
    text-align: center;
    max-width: 500px;
  `;
}
